export const getAbsoluteSize = () => {};
